/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Bundled_NoteInputs */

const cs_billing_bundled_note = /** @type {(inputs: Billing_Bundled_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platby za tuto licenci spravuje franchisor — přepínání fakturace je pro tuto kancelář nedostupné.`)
};

const en_billing_bundled_note = /** @type {(inputs: Billing_Bundled_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing for this license is managed by the franchisor — switching billing mode is unavailable for this office.`)
};

/**
* | output |
* | --- |
* | "Billing for this license is managed by the franchisor — switching billing mode is unavailable for this office." |
*
* @param {Billing_Bundled_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_bundled_note = /** @type {((inputs?: Billing_Bundled_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Bundled_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_bundled_note(inputs)
	return cs_billing_bundled_note(inputs)
});